import SubscriptionTypeInfo from '@/components/subscriptiontypes/Info';
import SelectType from '@/components/subscriptions/SelectType';
import DiscountCode from '@/components/billing/DiscountCode';
import BillingList from '@/components/billing/List';
import ChangeConfirm from '@/components/subscriptions/ChangeConfirm';
import SubscriptionService from '@/services/SubscriptionService';
import Loading from '@/components/widget/Loading';
import Breakdown from '@/components/billing/Breakdown';
export default {
  name: 'Change',
  props: {
    subscription: Object,
    subscriptiontype: {
      type: Object,
      default() {
        return null;
      }
    },
    status: {
      type: Object,
      default() {
        return null;
      }
    },
    types: Array,
    states: Array,
    countries: Array
  },
  components: {
    SubscriptionTypeInfo,
    SelectType,
    DiscountCode,
    BillingList,
    ChangeConfirm,
    Loading,
    Breakdown
  },
  data() {
    return {
      openModal: false,
      openConfirm: false,
      confirm: false,
      loading: false,
      calculating: false,
      discount: null,
      newsubscription: null,
      billing: {}
    };
  },
  methods: {
    init(skipLoader) {
      if (!skipLoader) {
        this.loading = true;
      }
      this.calculating = true;
      SubscriptionService.changeInit(this.subscription ? this.subscription.id : null, this.subscriptiontype.id, this.discount).then(response => {
        this.newsubscription = response.data;
      }).catch(error => {
        this.$aim.error(error.response);
      }).finally(() => {
        this.loading = false;
        this.calculating = false;
      });
    },
    confirmChange() {
      if (this.isValid) {
        this.newsubscription.billing = this.billing;
        if (!this.newsubscription.subscriptiontype) {
          this.newsubscription.subscriptiontype = this.subscriptiontype;
        }
        if (this.discount) {
          this.newsubscription.discount = this.discount;
        }
        this.confirm = true;
        this.$nextTick(() => {
          this.openConfirm = true;
        });
      }
    },
    setBilling(info) {
      this.billing = info;
    },
    setSubscriptionType(type) {
      this.newsubscription.subscriptiontype = type;
      this.$nextTick(() => {
        this.init(true);
      });
    },
    applyDiscount(discount) {
      this.discount = discount;
      this.$nextTick(() => {
        this.init(true);
      });
    }
  },
  computed: {
    /** @returns {Number} */
    amountDue() {
      let amt = 0;
      if (this.newsubscription && this.discount && this.discount.id > 0) {
        amt = parseFloat(this.discount.balancedue.amount);
      } else if (this.newsubscription) {
        amt = parseFloat(this.newsubscription.billingamount);
      } else {
        amt = this.subscriptiontype.amount;
      }
      return amt;
    },
    /** @returns {String} */
    amountDueFormatted() {
      let amt = 0;
      if (this.newsubscription && this.discount && this.discount.id > 0) {
        if (this.discount.balancedue.amount > 0) {
          amt = this.discount.balancedue.localcurrencyformatted;
        } else {
          amt = this.discount.subscriptiontype.localcurrencyformatted;
        }
      } else if (this.newsubscription && this.newsubscription.localbillingamount) {
        amt = this.newsubscription.localbillingamount.localcurrencyformatted;
      } else {
        amt = this.subscriptiontype.localcurrencyformatted;
      }
      return amt;
    },
    isValid() {
      return this.newsubscription && this.newsubscription.subscriptiontype_id > 0 && (this.amountDue <= 0 || this.billing && this.billing.id);
    }
  }
};